// extracted by mini-css-extract-plugin
module.exports = {"container":"Dialog_container__1RraD","dialog":"Dialog_dialog__2BVbK","title":"Dialog_title__FeXbk","children":"Dialog_children__18uVj"};